export enum MsFileTypes {
  CSV = "CSV",
  DOC = "DOC",
  DOCX = "DOCX",
  DOCM = "DOCM",
  DOT = "DOT",
  DOTM = "DOTM",
  DOTX = "DOTX",
  ODP = "ODP",
  ODS = "ODS",
  ODT = "ODT",
  POT = "POT",
  POTM = "POTM",
  POTX = "POTX",
  PPS = "PPS",
  PPSM = "PPSM",
  PPSX = "PPSX",
  PPT = "PPT",
  PPTM = "PPTM",
  PPTX = "PPTX",
  XLS = "XLS",
  XLSB = "XLSB",
  XLSM = "XLSM",
  XLSX = "XLSX",
  XLT = "XLT",
  XLTM = "XLTM",
  XLTX = "XLTX",
}

export enum XLTFileTypes {
  XLT = "XLT",
  XLTM = "XLTM",
  XLTX = "XLTX",
}

export enum RenditionFileTypes {
  PDF = "PDF",
  AI = "AI",
  PS = "PS",
  INDD = "INDD",
}

export enum ImageFileTypes {
  SKETCH = "SKETCH",
}

export enum CheckerboardTypes {
  PNG = "PNG",
  SKETCH = "SKETCH",
  EPS = "EPS",
  TIF = "TIF",
  TIFF = "TIFF",
  PSD = "PSD",
  GIF = "GIF",
}

export enum RenditionCodes {
  SMALL = 1,
  MEDIUM = 3,
  LARGE = 4,
}

export enum MediaTypes {
  FILE = "File",
  IMAGE = "Image",
  VIDEO = "Video",
  AUDIO = "Audio",
}

export enum ErrorTypes {
  API_NOT_CONFIGFURED = "Api not configured",
  UNAUTHORIZED = "Unauthorized",
  NOT_FOUND = "Not found",
}
